import { designHistoryRecord } from './designHistorySlice.js';
import {
  designStore,
  designUpdateStoreLayout,
  updateBackground,
  updateBodyFont,
  updateFont,
  updateHeadingFont,
  updateIsHideLogo,
  updatePageNavigation,
  updatePaletteId,
  updatePostsDesign,
  updatePreviewBackgroundColor,
  updatePreviewProfileImage,
  updateSubtitleFont,
  updateTabs,
  updateTemplateId,
  updateThemeId,
  updateThemeMode,
  updateThemeTokens,
} from './designSlice.js';

// Design actions that count as an undoable edit. `designStore` (full hydrate)
// is included so template/theme/palette/brand-color applies land in history —
// but only while the Design editor is open (see `enabled`), so the initial
// profile hydrate and page switches don't pollute the stack.
const CAPTURED = new Set(
  [
    updateBackground,
    updateFont,
    updateHeadingFont,
    updateSubtitleFont,
    updateBodyFont,
    updatePreviewBackgroundColor,
    updatePreviewProfileImage,
    updatePageNavigation,
    updateTabs,
    updatePostsDesign,
    updateTemplateId,
    updateThemeId,
    updatePaletteId,
    designUpdateStoreLayout,
    updateIsHideLogo,
    updateThemeMode,
    updateThemeTokens,
    designStore,
  ].map((a) => a.type),
);

// Consecutive captured actions within this window collapse into ONE history
// entry — so a slider drag, or the paired updateThemeId + designStore of a
// single theme click, become a single undo step.
const COALESCE_MS = 350;

let lastRecordAt = 0;

export const designHistoryMiddleware = (store) => (next) => (action) => {
  // `enabled` lives in the store (set by the Design editor on mount) so this
  // reads the single source of truth even if the module is split across chunks.
  if (action && CAPTURED.has(action.type) && store.getState().designHistory?.enabled) {
    const now = Date.now();
    if (now - lastRecordAt >= COALESCE_MS) {
      // Snapshot the pre-mutation state. Themes/templates/palettes change the
      // block designs (radius, etc.) too, so we capture blocks + dragList
      // alongside design (deep clone so later edits can't mutate the snapshot).
      const state = store.getState();
      const snapshot = JSON.parse(
        JSON.stringify({
          design: state.design,
          blocks: state.blocks.list,
          dragList: state.blocks.dragList,
        }),
      );
      store.dispatch(designHistoryRecord(snapshot));
    }
    lastRecordAt = now;
  }
  return next(action);
};
